import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import "./style.css";

const productSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "רישיון נהיגה בינלאומי דיגיטלי",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "item": {
        "@type": "Product",
        "name": "רישיון נהיגה בינלאומי דיגיטלי – מסלול רגיל",
        "description": "רישיון נהיגה בינלאומי דיגיטלי תקף לשנה אחת, מוכן תוך 24 שעות מרגע ההזמנה.",
        "offers": {
          "@type": "Offer",
          "price": "29",
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock"
        }
      }
    },
    {
      "@type": "ListItem",
      "position": 2,
      "item": {
        "@type": "Product",
        "name": "רישיון נהיגה בינלאומי דיגיטלי – מסלול מהיר",
        "description": "רישיון נהיגה בינלאומי דיגיטלי אקספרס, מוכן תוך 60 דקות מרגע ההזמנה.",
        "offers": {
          "@type": "Offer",
          "price": "69",
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock"
        }
      }
    }
  ]
};

const MainContent = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'product-schema';
    script.textContent = JSON.stringify(productSchema);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById('product-schema');
      if (existing) existing.remove();
    };
  }, []);

  return (
  <div className="main-content">
    <h2 className="section_title">הפקת רישיון נהיגה בינלאומי דיגיטלי אונליין</h2>
    <section>
      <h3 className="section_title">איך מפיקים רישיון נהיגה בינלאומי דיגיטלי אונליין?</h3>
      <p>
        הפקת רישיון נהיגה בינלאומי דיגיטלי אונליין מתבצעת בתהליך קצר ופשוט: מעלים צילום ברור של רישיון הנהיגה הישראלי, משלימים פרטים אישיים, ומבצעים תשלום מאובטח באתר. לאחר הבדיקה, הרישיון הבינלאומי הדיגיטלי נשלח למייל בהתאם למסלול שבחרתם.
      </p>
    </section>

    <section>
      <h3 className="section_title">למה לבחור בהנפקת רישיון נהיגה בינלאומי אונליין?</h3>
      <p>
        הוצאת רישיון נהיגה בינלאומי אונליין חוסכת זמן ומאפשרת לכם לבצע את כל התהליך מכל מקום ובכל שעה. אין צורך להגיע לסניף, אין המתנה בתור, והכל מתבצע בצורה דיגיטלית ונוחה לפני טיסה, חופשה או השכרת רכב בחו"ל.
      </p>
    </section>

    <section>
      <h3 className="section_title">סוגי רישיונות בינלאומיים דיגיטליים וזמני הכנה</h3>
      <p>
        רישיון הנהיגה הבינלאומי שלנו הוא דיגיטלי וניתן להזמנה אונליין. הרישיון תקף לשנה אחת, עולה 29$, ומוכן בתוך 24 שעות מרגע ההזמנה. אם אתם צריכים רישיון בינלאומי בדחיפות, אפשר להזמין מסלול מהיר במחיר 69$.
        רישיון זה מוכן תוך 60 דקות מרגע ההזמנה.
      </p>
    </section>

    <section>
      <h3 className="section_title">האם רישיון נהיגה בינלאומי דיגיטלי תקף בכל מקום?</h3>
      <p>
        חשוב לבדוק מראש מול חברת ההשכרה או הגורם הרלוונטי במדינת היעד. חברות שונות עשויות לדרוש רישיון נהיגה בינלאומי מודפס ולא תמיד מקבלות רישיון דיגיטלי. לפני הזמנה, ודאו שהרישיון הדיגיטלי מתאים לצורך שלכם.
      </p>
    </section>

    <section>
      <h3 className="section_title">שאלות נפוצות על הוצאת רישיון נהיגה בינלאומי אונליין</h3>
      <p>
        ניתן להשלים הנפקת רישיון נהיגה בינלאומי דיגיטלי אונליין בתוך דקות בודדות, כל עוד יש לכם צילום ברור של רישיון הנהיגה הישראלי ואמצעי תשלום תקף.
      </p>
      <p>
        אם אתם מתכננים נהיגה בחו"ל, מומלץ לבצע הזמנת רישיון נהיגה בינלאומי באינטרנט מראש כדי להימנע מעיכובים ברגע האחרון.
      </p>
    </section>

    <section>
      <h3 className="section_title">מאמרים ומידע נוסף לפי מדינה</h3>
      <p>
        <Link to="japan-driving-license">שימוש ברישיון הנהיגה הדיגיטלי שלנו ביפן</Link>
      </p>
      <p>
        <Link to="thailand-driving-license">שימוש ברישיון הנהיגה הדיגיטלי שלנו בתאילנד</Link>
      </p>
      <p>
        <Link to="italy-driving-license">שימוש ברישיון הנהיגה הדיגיטלי שלנו באיטליה</Link>
      </p>
    </section>
  </div>
  );
};

export default MainContent;